type Tier = 'plus' | 'pro';
const GEM_MARK_IMG = require('../../../assets/branding/ai-mark-tabbio.png');

const toAssetSrc = (asset: unknown): string =>
  typeof asset === 'string'
    ? asset
    : (asset as { uri?: string; default?: string } | null)?.uri ??
      (asset as { default?: string } | null)?.default ??
      '';

const GEM_MARK_SRC = toAssetSrc(GEM_MARK_IMG);

// Figma sparkle (node 2476:8405). Inline vector: no raster asset, no baked
// background: so it sits cleanly on the surface.
const SPARK_PATH =
  'M31.7449 2.4425C39.0552 2.4425 38.1082 12.9246 44.3071 19.1234C50.5059 25.3223 60.988 24.3753 60.988 31.6856C60.988 38.996 50.506 38.0489 44.3071 44.2478C38.1082 50.4467 39.0552 60.9287 31.7449 60.9287C24.4346 60.9287 25.3816 50.4467 19.1827 44.2478C12.9838 38.0489 2.50178 38.996 2.50178 31.6856C2.50178 24.3753 12.9838 25.3223 19.1827 19.1234C25.3816 12.9246 24.4346 2.4425 31.7449 2.4425Z';

export function SparkleGlyph({ size, id = 'spark' }: { size: number; id?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 63.4305 63.3712"
      fill="none"
      style={{ display: 'block' }}
      aria-hidden
    >
      <defs>
        <linearGradient
          id={`sparkFill-${id}`}
          x1="47.5877"
          y1="15.8428"
          x2="15.9021"
          y2="47.5284"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#E8E3FA" />
          <stop offset="0.41" stopColor="#B8A3FF" />
          <stop offset="1" stopColor="#7A52FE" />
        </linearGradient>
        <linearGradient
          id={`sparkRim-${id}`}
          x1="31.6856"
          y1="0"
          x2="31.6856"
          y2="63.3712"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#F2EFFD" />
          <stop offset="0.534" stopColor="#B5B4FF" />
          <stop offset="0.884" stopColor="#97ECFE" />
        </linearGradient>
      </defs>
      <path
        d={SPARK_PATH}
        fill={`url(#sparkFill-${id})`}
        stroke={`url(#sparkRim-${id})`}
        strokeWidth={1.4}
      />
    </svg>
  );
}

/** Paywall header uses the Tabbio gem mark; tier marks live in the feature table. */
export function UpgradeGemMark({ size = 56 }: { size?: number }) {
  const markHeight = Math.round(size * (44 / 56));

  return (
    <img
      src={GEM_MARK_SRC}
      alt=""
      width={size}
      height={markHeight}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  );
}

/** Hero keeps the Tabbio gem mark; the per-screen agent mark (spark on Plus,
 * Nova on Pro) lives on its feature row in the table. */
export function UpgradeHeroIcon({ tier: _tier, size = 56 }: { tier: Tier; size?: number }) {
  const markHeight = Math.round(size * (44 / 56));

  return (
    <div
      style={{
        width: size + 14,
        height: markHeight + 12,
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <UpgradeGemMark size={size} />
    </div>
  );
}
